<app-navbar-component></app-navbar-component>
<div class="m-x-auto">
    <h1 class="display-header">🔥️ Ares</h1>
    <p class="text-center">Antaragni'22 Backend</p>
</div>
<div class="container">
    <router-outlet></router-outlet>
</div>